import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const ClassXIOptionForm = () => {
  useEffect(() => {
    document.title =
      "Class XI Option Form -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admissions </li>

          <li>Class XI Option Form</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Class XI Option Form </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassXIOptionForm.pdf"
                width="100%"
                height="600"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassXIOptionForm;
